<app-dialog [show]="show" [header]="'Edit My Profile'">
  <div class="edit-profile-dialog-container">
    <form class="form edit-profile-form"
          (ngSubmit)="saveProfile()"
          [formGroup]="editAccountForm"
    >
      <div class="inputs-container">
        <app-input class="half-width"
                   [label]="'First Name'"
                   formControlName="firstName"
                   [autofocus]="show"
                   (keyupEnter)="focusInput('lastNameInput')"
        ></app-input>
        <app-input class="half-width"
                   [label]="'Last Name'"
                   formControlName="lastName"
                   #lastNameInput
                   (keyupEnter)="focusInput('emailInput')"
        ></app-input>
      </div>

      <div class="inputs-container">
        <app-input class="half-width"
                   type="email"
                   [label]="'Email'"
                   formControlName="email"
                   #emailInput
        ></app-input>
        <div class="half-width"></div>
<!--        <app-input class="half-width"-->
<!--                   disable-->
<!--                   [label]="'Role'"-->
<!--                   formControlName="role"-->
<!--        ></app-input>-->
      </div>

      <div class="toggle-option-container" [class.opened]="showUpdatePassword">
        <div class="toggle-option-label first">
        <span (click)="toggleUpdatePassword(true)"
              [ngClass]="{'animation-focus-default': !showUpdatePassword}"
              class="option-expand"
        >
          Update my password
        </span>
          <span (click)="toggleUpdatePassword(false)"
                class="option-collapse animation-focus-default"
          >
          Cancel
        </span>
        </div>

        <div class="toggle-option-wrapper">
          <div class="inputs-container">
            <app-input class="half-width"
                       type="password"
                       [label]="'Current password'"
                       formControlName="currentPassword"
                       #currentPasswordInput
                       (keyupEnter)="focusInput('newPassword')"
            ></app-input>
            <app-input class="half-width"
                       type="password"
                       [label]="'New password'"
                       formControlName="newPassword"
                       #newPasswordInput
            ></app-input>
          </div>
        </div>
      </div>

      <div class="toggle-option-container" [class.opened]="showUpdatePIN">
        <div class="toggle-option-label">
        <span (click)="toggleUpdatePIN(true)"
              [ngClass]="{'animation-focus-default': !showUpdatePIN}"
              class="option-expand"
        >
          Update my PIN
        </span>
          <span (click)="toggleUpdatePIN(false)"
                class="option-collapse animation-focus-default"
          >
          Cancel
        </span>
        </div>

        <div class="toggle-option-wrapper">
          <div class="inputs-container half-width-input">
            <div class="label default">Current PIN</div>
            <app-pin-input (pinValueComplete)="setCurrentPIN($event)"
                           [invalid]="isInvalidCurrentPin"
                           #currentPinInput
            ></app-pin-input>
          </div>

          <div class="inputs-container half-width-input">
            <div class="label default">New PIN</div>
            <app-pin-input [validateSequence]="true"
                           (pinValueComplete)="setNewPIN($event)"
                           #newPinInput
            ></app-pin-input>
            <div *ngIf="pinErrorMessage" class="error-message">{{pinErrorMessage}}</div>
          </div>
        </div>
      </div>

      <div class="dialog-controls-default">
        <app-button [minWidth]="0"
                    customClasses="px-4"
                    text="Cancel"
                    subStyle="transparent"
                    class="cancel"
                    (clicked)="cancelEdit()"
        >
        </app-button>

        <app-button customClasses="px-4"
                    [minWidth]="0"
                    text="Save Changes"
                    class="close-account"
                    [disabled]="editAccountForm.invalid"
                    type="submit"
                    #saveChangesButton
        >
        </app-button>
      </div>
    </form>
  </div>
</app-dialog>
